module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch2"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage3"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch2.jpg",
      "width": "5%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pg-2"
    }
  }, [_vm._v("“Are you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sure")]), _vm._v(" your mom works for Dr. Eeek?” the receptionist grills you. She raises an eyebrow.")])]), _c('a', {
    attrs: {
      "id": "pg-2"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her eyebrows give you the creeps.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In fact, this whole place gives you the creeps.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("From the minute you stepped off the elevator on the nineteenth floor, there were no signs of life. No one in the echoing hall. Nothing but the creaking elevator door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And then you spotted the door to Eeek Labs. Your mother never told you about that, either. The door looked like the door to a huge "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("vault")]), _vm._v("! It was heavy steel — and about six inches thick.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Your best friend, Sam, pulled a small handle near the edge of the door. To your surprise, the door swung open easily.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Okay, you told yourself. So the place has a weird door. That’s no reason to freak out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah, she works here,” you tell the receptionist. “She does research.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, take a seat,” she replies. “I’m sure your mom will be right here.” Then she packs up her oversized tote bag and walks out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("You search around for a chair. Then you see them. Across the room. The chairs are all orange plastic — and they’re all chained together!")])]), _c('p', {
    staticClass: "extractLetterText",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pg-2"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Sit down on")])]), _c('a', {
    attrs: {
      "href": "#/e9780545841054_ch003"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PAGE 3")])]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9672f96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545841054_ch002.vue
// module id = 69
// module chunks = 0